import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.proposal');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-proposal',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.proposal/view.scss */
:host {
  display: block;
  min-height: 100%;
  background: #f6f7f4;
  color: #17202a;
}

.page-wrap {
  max-width: 1360px;
  margin: 0 auto;
  padding: 34px 28px 56px;
}

.work-header,
.table-panel,
.modal-panel {
  border: 1px solid #dfe3db;
  background: #ffffff;
  box-shadow: 0 18px 44px rgba(23, 32, 42, 0.06);
}

.work-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  padding: 28px;
  border-radius: 8px;
}

.header-copy h1 {
  margin: 6px 0 8px;
  font-size: 30px;
  font-weight: 800;
  letter-spacing: 0;
}

.header-copy p {
  margin: 0;
  max-width: 680px;
  color: #657069;
  font-size: 15px;
  line-height: 1.65;
}

.eyebrow,
.section-kicker,
.metric-card .label,
.command-card .label {
  color: #b28921;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
}

.header-actions,
.modal-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

button {
  font: inherit;
}

.primary-btn,
.secondary-btn,
.table-btn,
.icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 8px;
  border: 1px solid transparent;
  cursor: pointer;
  transition: 0.16s ease;
  white-space: nowrap;
}

.primary-btn {
  min-height: 42px;
  padding: 0 16px;
  background: #10375c;
  color: #ffffff;
  font-weight: 800;
}

.primary-btn:hover {
  background: #0b2947;
}

.primary-btn:disabled,
.secondary-btn:disabled,
.icon-btn:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.secondary-btn {
  min-height: 42px;
  padding: 0 15px;
  background: #ffffff;
  border-color: #d8ded6;
  color: #27313d;
  font-weight: 750;
}

.secondary-btn:hover {
  border-color: #10375c;
  color: #10375c;
}

.command-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  margin-top: 18px;
}

.command-card {
  display: grid;
  grid-template-columns: 54px 1fr auto;
  align-items: center;
  gap: 18px;
  width: 100%;
  min-height: 116px;
  padding: 20px;
  border: 1px solid #dfe3db;
  border-radius: 8px;
  background: #ffffff;
  color: inherit;
  text-align: left;
  box-shadow: 0 14px 34px rgba(23, 32, 42, 0.05);
}

.command-card:hover {
  border-color: #b28921;
  transform: translateY(-1px);
}

.command-card.is-strong {
  border-color: #cda83c;
  background: #fffaf0;
}

.command-icon {
  display: grid;
  place-items: center;
  width: 54px;
  height: 54px;
  border-radius: 8px;
  background: #eef4f1;
  color: #0f6b57;
  font-size: 21px;
}

.command-card.is-strong .command-icon {
  background: #10375c;
  color: #fff;
}

.command-body {
  display: grid;
  gap: 5px;
}

.command-body strong {
  font-size: 18px;
  font-weight: 850;
}

.command-body small {
  color: #6a746f;
  font-size: 13px;
  line-height: 1.45;
}

.command-arrow {
  color: #9aa39c;
}

.metric-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
  margin-top: 18px;
}

.metric-card {
  padding: 18px;
  border: 1px solid #dfe3db;
  border-radius: 8px;
  background: #ffffff;
  cursor: pointer;
  text-align: left;
}

.metric-card strong {
  display: block;
  margin-top: 10px;
  font-size: 26px;
  font-weight: 850;
  color: #10375c;
}

.metric-card small {
  color: #717b75;
}

.metric-card:hover,
.metric-card.is-active {
  border-color: #0f766e;
  background: #ecfdf5;
}

.table-panel {
  margin-top: 18px;
  border-radius: 8px;
  overflow: hidden;
}

.panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 22px 24px;
  border-bottom: 1px solid #e4e7e1;
}

.panel-title h2,
.modal-title h2 {
  margin: 4px 0 0;
  font-size: 20px;
  font-weight: 850;
}

.panel-count {
  padding: 6px 10px;
  border-radius: 999px;
  background: #eef4f1;
  color: #0f6b57;
  font-size: 13px;
  font-weight: 800;
}

.table-wrap {
  overflow-x: auto;
}

.data-table {
  width: 100%;
  min-width: 1160px;
  border-collapse: collapse;
}

.data-table th {
  padding: 13px 18px;
  background: #f2f4f1;
  color: #657069;
  font-size: 12px;
  font-weight: 850;
  text-align: left;
}

.data-table td {
  padding: 16px 18px;
  border-top: 1px solid #edf0eb;
  color: #26313d;
  vertical-align: middle;
}

.data-table tbody tr {
  cursor: pointer;
}

.data-table tbody tr:hover {
  background: #fbfcfa;
}

.title-cell {
  min-width: 310px;
}

.title-line {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  min-width: 0;
}

.title-cell strong {
  display: block;
  min-width: 0;
  font-weight: 850;
  line-height: 1.45;
}

.codex-title-tag {
  display: inline-flex;
  align-items: center;
  min-height: 20px;
  padding: 0 7px;
  border: 1px solid #b9d9e8;
  border-radius: 999px;
  background: #e8f6fb;
  color: #0b5f85;
  font-size: 11px;
  font-weight: 850;
  line-height: 1;
  flex: 0 0 auto;
}

.title-cell > span,
.date-text,
.doc-count {
  display: block;
  margin-top: 4px;
  color: #88928c;
  font-size: 12px;
}

.source-pill,
.status-badge {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 0 10px;
  border-radius: 999px;
  background: #eef0ed;
  color: #626b66;
  font-size: 12px;
  font-weight: 800;
}

.source-pill.is-manual {
  background: #fff2d6;
  color: #94690c;
}

.source-pill.is-codex {
  background: #e8f6fb;
  color: #0b5f85;
}

.status-badge.is-done {
  background: #e9f7ef;
  color: #14754e;
}

.status-badge.is-progress {
  background: #eaf2ff;
  color: #1c5d99;
}

.deadline {
  color: #10375c;
  font-weight: 850;
}

.action-cell {
  display: flex;
  gap: 8px;
}

.table-btn {
  min-height: 34px;
  padding: 0 11px;
  border-color: #d8ded6;
  background: #fff;
  color: #2b3440;
  font-size: 13px;
  font-weight: 800;
}

.table-btn.primary {
  background: #10375c;
  border-color: #10375c;
  color: #fff;
}

.table-btn.danger {
  width: 34px;
  padding: 0;
  color: #b23b35;
}

.pagination {
  display: flex;
  justify-content: center;
  gap: 6px;
  padding: 18px 22px 22px;
  border-top: 1px solid #edf0eb;
}

.page-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  height: 36px;
  border: 1px solid #d8ded6;
  border-radius: 8px;
  background: #fff;
  color: #4d5751;
  font-weight: 850;
  cursor: pointer;
}

.page-btn.is-active {
  border-color: #10375c;
  background: #10375c;
  color: #fff;
}

.page-btn:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.loading-state,
.empty-state {
  display: grid;
  place-items: center;
  gap: 12px;
  min-height: 280px;
  padding: 36px;
  color: #717b75;
  text-align: center;
}

.empty-state i {
  color: #b7beb7;
  font-size: 34px;
}

.empty-state strong {
  color: #1d2732;
  font-size: 18px;
}

.empty-state p {
  margin: 0;
}

.spinner {
  width: 34px;
  height: 34px;
  border: 3px solid #dfe3db;
  border-top-color: #10375c;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 50;
  display: grid;
  place-items: center;
  padding: 24px;
  background: rgba(15, 22, 31, 0.42);
}

.modal-panel {
  width: min(620px, 100%);
  border-radius: 8px;
  overflow: hidden;
}

.modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 22px 24px;
  border-bottom: 1px solid #e4e7e1;
}

.icon-btn {
  width: 36px;
  height: 36px;
  background: #fff;
  border-color: #d8ded6;
  color: #657069;
}

.form-grid {
  display: grid;
  gap: 14px;
  padding: 24px;
}

.field {
  display: grid;
  gap: 8px;
  color: #2c3642;
  font-size: 13px;
  font-weight: 850;
}

.field input {
  width: 100%;
  height: 44px;
  padding: 0 13px;
  border: 1px solid #d8ded6;
  border-radius: 8px;
  outline: none;
}

.field input:focus {
  border-color: #10375c;
}

.file-drop {
  display: grid;
  place-items: center;
  gap: 7px;
  min-height: 150px;
  padding: 22px;
  border: 1px dashed #b9c2b9;
  border-radius: 8px;
  background: #fbfcfa;
  color: #66716a;
  text-align: center;
  cursor: pointer;
}

.file-drop input {
  display: none;
}

.file-drop i {
  color: #0f6b57;
  font-size: 27px;
}

.file-drop strong {
  color: #17202a;
}

.file-drop em {
  color: #0f6b57;
  font-style: normal;
  font-weight: 800;
}

.upload-file-list {
  display: grid;
  gap: 8px;
  padding: 12px;
  border: 1px solid #e4e7df;
  border-radius: 8px;
  background: #ffffff;
}

.upload-file-head,
.upload-file-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.upload-file-head {
  justify-content: space-between;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f2ed;
}

.upload-file-head strong {
  display: block;
  color: #17202a;
  font-size: 12px;
  font-weight: 800;
}

.upload-file-head span {
  color: #66716a;
  font-size: 11px;
}

.upload-file-row {
  min-height: 42px;
  padding: 8px;
  border: 1px solid #edf0e9;
  border-radius: 7px;
  background: #fbfcfa;
}

.upload-file-row.is-uploading {
  border-color: #cfe8df;
  background: #f4fbf8;
}

.upload-progress {
  display: grid;
  gap: 10px;
  padding: 12px;
  border: 1px solid #d8eee7;
  border-radius: 8px;
  background: #f4fbf8;
}

.upload-progress-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
}

.upload-progress-head div {
  min-width: 0;
}

.upload-progress-head strong {
  display: block;
  color: #0f5f59;
  font-size: 12px;
  font-weight: 800;
}

.upload-progress-head span {
  display: block;
  margin-top: 3px;
  color: #617069;
  font-size: 11px;
  line-height: 1.45;
}

.upload-progress-head b {
  color: #0f766e;
  font-size: 13px;
  font-weight: 850;
  white-space: nowrap;
}

.upload-progress-track {
  position: relative;
  overflow: hidden;
  height: 8px;
  border-radius: 999px;
  background: #dce7e2;
}

.upload-progress-fill {
  position: absolute;
  inset: 0 auto 0 0;
  min-width: 10px;
  border-radius: inherit;
  background: linear-gradient(90deg, #0f766e, #16a085);
  transition: width 0.22s ease;
}

.upload-progress-fill.is-parsing::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.55), transparent);
  animation: progress-shine 1.15s linear infinite;
}

.upload-progress-steps {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
}

.upload-step {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 0;
  min-height: 28px;
  padding: 0 8px;
  border: 1px solid #e2e8e5;
  border-radius: 7px;
  background: #ffffff;
  color: #7c8882;
  font-size: 11px;
  font-weight: 700;
}

.upload-step i {
  font-size: 10px;
}

.upload-step.is-active,
.upload-step.is-done {
  border-color: #99f6e4;
  background: #ecfdf5;
  color: #0f766e;
}

.upload-file-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 30px;
  width: 30px;
  height: 30px;
  border-radius: 7px;
  background: #eef7f3;
  color: #0f6b57;
}

.upload-file-meta {
  display: grid;
  min-width: 0;
  gap: 2px;
  flex: 1;
}

.upload-file-meta strong {
  overflow: hidden;
  color: #17202a;
  font-size: 12px;
  font-weight: 750;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.upload-file-meta span {
  color: #66716a;
  font-size: 11px;
}

.clear-file-btn,
.remove-file-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1px solid #e4e7df;
  border-radius: 7px;
  background: #ffffff;
  color: #66716a;
  cursor: pointer;
  transition: 0.16s ease;
}

.clear-file-btn {
  min-height: 30px;
  padding: 0 10px;
  font-size: 11px;
  font-weight: 700;
}

.remove-file-btn {
  flex: 0 0 28px;
  width: 28px;
  height: 28px;
  padding: 0;
}

.clear-file-btn:hover,
.remove-file-btn:hover {
  border-color: #f1b5ad;
  background: #fff4f2;
  color: #a0342b;
}

.clear-file-btn:disabled,
.remove-file-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.error-box {
  display: flex;
  gap: 8px;
  margin: 0 24px 16px;
  padding: 12px;
  border: 1px solid #f1b5ad;
  border-radius: 8px;
  background: #fff4f2;
  color: #a0342b;
  font-size: 13px;
}

.modal-actions {
  justify-content: flex-end;
  padding: 18px 24px 24px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes progress-shine {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(100%);
  }
}
@media (max-width: 980px) {
  .work-header,
  .panel-head {
    align-items: flex-start;
    flex-direction: column;
  }
  .header-actions,
  .modal-actions {
    width: 100%;
    flex-wrap: wrap;
  }
  .primary-btn,
  .secondary-btn {
    flex: 1 1 180px;
  }
  .command-grid,
  .metric-grid {
    grid-template-columns: 1fr;
  }
  .page-wrap {
    padding: 20px 14px 40px;
  }
}
/* Library-tone compact overrides */
:host {
  background: #fafafa;
  color: #18181b;
}

.page-wrap {
  max-width: 1400px;
  padding: 20px 24px 60px;
}

.work-header {
  align-items: flex-start;
  padding: 0 0 12px;
  margin-bottom: 16px;
  border: 0;
  border-bottom: 1px solid #e4e4e7;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.header-copy h1 {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
}

.header-copy p {
  max-width: none;
  font-size: 12px;
  line-height: 1.45;
  color: #71717a;
}

.eyebrow,
.section-kicker,
.metric-card .label,
.command-card .label {
  color: #0f766e;
  font-size: 11px;
  font-weight: 650;
  text-transform: none;
}

.primary-btn,
.secondary-btn,
.table-btn,
.icon-btn {
  min-height: 32px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
}

.primary-btn {
  background: #0f766e;
}

.primary-btn:hover {
  background: #0b5f59;
}

.secondary-btn {
  border-color: #e4e4e7;
  color: #52525b;
}

.secondary-btn:hover {
  border-color: #99f6e4;
  color: #0f766e;
  background: #ecfdf5;
}

.command-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-top: 0;
  margin-bottom: 12px;
}

.command-card {
  grid-template-columns: 34px 1fr auto;
  min-height: auto;
  gap: 10px;
  padding: 12px;
  border-color: #e4e4e7;
  box-shadow: none;
}

.command-card:hover {
  border-color: #99f6e4;
  transform: none;
  background: #fafafa;
}

.command-card.is-strong {
  border-color: #99f6e4;
  background: #ecfdf5;
}

.command-icon,
.command-card.is-strong .command-icon {
  width: 34px;
  height: 34px;
  border-radius: 6px;
  background: #f4f4f5;
  color: #0f766e;
  font-size: 14px;
}

.command-body {
  gap: 2px;
}

.command-body strong {
  font-size: 13px;
  font-weight: 650;
}

.command-body small {
  font-size: 11px;
  color: #71717a;
}

.metric-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 0;
  margin-bottom: 12px;
}

.metric-card {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 28px;
  padding: 0 10px;
  border-color: #e4e4e7;
  border-radius: 999px;
  background: #f4f4f5;
}

.metric-card:hover,
.metric-card.is-active {
  border-color: #99f6e4;
  background: #ecfdf5;
  color: #0f766e;
}

.metric-card strong {
  display: inline;
  margin: 0;
  color: #52525b;
  font-size: 11px;
  font-weight: 700;
}

.metric-card small {
  display: none;
}

.table-panel,
.modal-panel {
  border-color: #e4e4e7;
  box-shadow: none;
}

.table-panel {
  margin-top: 12px;
}

.panel-head,
.modal-head {
  min-height: 48px;
  padding: 12px 14px;
  border-bottom-color: #f4f4f5;
}

.panel-title h2,
.modal-title h2 {
  margin: 2px 0 0;
  font-size: 15px;
  font-weight: 700;
}

.panel-count {
  padding: 4px 8px;
  background: #f4f4f5;
  color: #52525b;
  font-size: 11px;
  font-weight: 650;
}

.data-table th {
  padding: 10px 14px;
  background: #fafafa;
  font-size: 11px;
  font-weight: 650;
}

.data-table td {
  padding: 12px 14px;
}

.title-cell strong,
.deadline {
  font-weight: 650;
}

.source-pill,
.status-badge,
.table-btn {
  min-height: 26px;
  font-size: 11px;
  font-weight: 600;
}

.status-badge.is-done,
.source-pill.is-manual {
  background: #ecfdf5;
  color: #0f766e;
}

.source-pill.is-codex,
.codex-title-tag {
  background: #e8f6fb;
  color: #0b5f85;
}

.table-btn.primary {
  background: #0f766e;
  border-color: #0f766e;
}

.pagination {
  padding: 12px 14px 14px;
}

.page-btn {
  min-width: 30px;
  height: 30px;
  border-color: #e4e4e7;
  border-radius: 6px;
  font-size: 11.5px;
  font-weight: 600;
}

.page-btn:hover {
  border-color: #99f6e4;
  color: #0f766e;
  background: #ecfdf5;
}

.page-btn.is-active {
  border-color: #0f766e;
  background: #0f766e;
}

.loading-state,
.empty-state {
  min-height: 220px;
  padding: 42px 20px;
}

.empty-state i {
  font-size: 26px;
}

.empty-state strong {
  font-size: 13px;
  font-weight: 650;
}

.form-grid,
.modal-actions {
  padding-left: 18px;
  padding-right: 18px;
}

/* Font scale refinement */
.proposal-page {
  font-size: 12px;
}

.header-copy h1 {
  font-size: 16px;
}

.header-copy p,
.command-body small,
.date-text,
.doc-count {
  font-size: 11.5px;
}

.panel-title h2,
.modal-title h2 {
  font-size: 14px;
}

.command-body strong,
.title-cell strong {
  font-size: 12px;
}

.primary-btn,
.secondary-btn,
.table-btn,
.source-pill,
.status-badge,
.field,
.file-drop {
  font-size: 11.5px;
}

.data-table td {
  font-size: 12px;
}

/* Softer generation/upload modal */
.modal-backdrop {
  background: rgba(24, 24, 27, 0.38);
  backdrop-filter: blur(2px);
}

.modal-panel {
  width: min(560px, 100vw - 32px);
  border-radius: 10px;
}

.modal-head {
  padding: 18px 20px 14px;
  background: #ffffff;
}

.modal-title .section-kicker {
  color: #71717a;
  font-size: 10.5px;
  font-weight: 600;
}

.modal-title h2 {
  font-size: 15px;
  font-weight: 650;
}

.form-grid {
  gap: 12px;
  padding: 18px 20px 16px;
}

.field {
  gap: 6px;
  color: #52525b;
  font-weight: 500;
}

.field input {
  height: 38px;
  border-color: #e4e4e7;
  border-radius: 7px;
  color: #18181b;
  font-size: 12px;
}

.field input:focus {
  border-color: #99f6e4;
  box-shadow: 0 0 0 3px rgba(15, 118, 110, 0.08);
}

.file-drop {
  min-height: 126px;
  gap: 5px;
  border-color: #d4d4d8;
  border-radius: 8px;
  background: #fafafa;
  color: #71717a;
}

.file-drop i {
  color: #0f766e;
  font-size: 22px;
}

.file-drop strong {
  color: #18181b;
  font-size: 12px;
  font-weight: 600;
}

.file-drop small {
  font-size: 11px;
  font-weight: 400;
}

.file-drop em {
  color: #0f766e;
  font-weight: 600;
}

.upload-file-list {
  gap: 7px;
  padding: 10px;
  border-color: #e4e4e7;
}

.upload-file-head {
  padding-bottom: 7px;
}

.upload-file-head strong,
.upload-file-meta strong {
  font-size: 11.5px;
}

.upload-file-row {
  min-height: 40px;
  padding: 7px;
  border-color: #eeeeef;
  background: #fafafa;
}

.upload-file-icon {
  flex-basis: 28px;
  width: 28px;
  height: 28px;
  background: #ecfdf5;
  color: #0f766e;
}

.upload-file-head span,
.upload-file-meta span,
.clear-file-btn {
  font-size: 10.5px;
}

.modal-actions {
  padding: 14px 20px 18px;
  border-top: 1px solid #f4f4f5;
}

.modal-actions .primary-btn,
.modal-actions .secondary-btn {
  min-height: 34px;
  font-weight: 600;
}`],
})
export class PageProposalComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public items: any[] = [];
    public loading: boolean = false;
    public proposalFilter: string = 'all';
    public page: number = 1;
    public pageSize: number = 10;

    public showUploadModal: boolean = false;
    public uploadTitle: string = '';
    public uploadOrg: string = '';
    public uploadFiles: File[] = [];
    public uploadError: string = '';
    public uploading: boolean = false;
    public uploadProgress: any = this.getInitialUploadProgress();
    private uploadProgressTimer: any = null;

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        await this.service.render();
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        try {
            let res = await wiz.call("list");
            if (res.code === 200) {
                this.items = res.data.rows || [];
                this.page = Math.min(this.page, this.totalPages);
            }
        } catch { }

        this.loading = false;
        await this.service.render();
    }

    public goToAnalysis() {
        this.service.href('/analysis?source=nara&entry=proposal');
    }

    public async openDetail(item: any) {
        await this.openProjectWorkspace(item);
    }

    public async createProposal(item: any, event?: any) {
        if (event) event.stopPropagation();
        await this.openProjectWorkspace(item);
    }

    private async openProjectWorkspace(item: any) {
        if (!item?.notice_no) return;
        const noticeNo = encodeURIComponent(item.notice_no);
        if (this.isCodexItem(item)) {
            this.service.href(`/codex/${noticeNo}`);
            return;
        }

        this.service.href(`/analysis/${noticeNo}?from=project`);
    }

    private async callProposalAction(functionName: string, noticeNo: string) {
        const url = wiz.url(functionName);
        const formData = new FormData();
        formData.append('notice_no', noticeNo);

        console.log(`[${functionName}] url:`, url);

        const response = await fetch(url, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin'
        });
        const rawText = await response.text();

        console.log(`[${functionName}] http:`, response.status, response.statusText);
        console.log(`[${functionName}] raw:`, rawText);

        try {
            return rawText ? JSON.parse(rawText) : { code: response.status, data: {} };
        } catch {
            return { code: response.status, data: { raw: rawText } };
        }
    }

    public async deleteNotice(item: any) {
        if (!confirm(`"${item.title || item.notice_no}" 항목을 삭제하시겠습니까?\n관련 RFP 문서와 제안서도 함께 삭제됩니다.`)) return;
        try {
            console.log('[deleteNotice] request:', item.notice_no, item);
            let res = await this.callProposalAction('delete_notice', item.notice_no);
            console.log('[deleteNotice] result:', JSON.stringify(res));
            if (res.code === 200 || res.code === 404) {
                await this.load();
            }
        } catch (error) {
            console.error('[deleteNotice] error:', error);
        }
        await this.service.render();
    }

    public async unscrapNotice(item: any) {
        if (!confirm(`"${item.title || item.notice_no}" 항목을 목록에서 제거하시겠습니까?\n관련 RFP 문서와 제안서도 함께 삭제됩니다.`)) return;
        try {
            console.log('[unscrapNotice] request:', item.notice_no, item);
            let res = await this.callProposalAction('unscrap', item.notice_no);
            console.log('[unscrapNotice] result:', JSON.stringify(res));
            if (res.code === 200 || res.code === 404) {
                await this.load();
            }
        } catch (error) {
            console.error('[unscrapNotice] error:', error);
        }
        await this.service.render();
    }

    // ── Upload modal ──

    public async openUpload() {
        this.showUploadModal = true;
        this.uploadTitle = '';
        this.uploadOrg = '';
        this.uploadFiles = [];
        this.uploadError = '';
        this.resetUploadProgress();
        await this.service.render();
    }

    public async closeUpload() {
        if (this.uploading) return;
        this.showUploadModal = false;
        this.uploadError = '';
        this.resetUploadProgress();
        await this.service.render();
    }

    public async onUploadFileChange(event: any) {
        this.uploadFiles = Array.from(event.target.files || []);
        this.uploadError = '';
        this.resetUploadProgress();
        if (event?.target) event.target.value = '';
        await this.service.render();
    }

    public async removeUploadFile(index: number) {
        if (this.uploading) return;
        this.uploadFiles = this.uploadFiles.filter((_, i) => i !== index);
        this.uploadError = '';
        this.resetUploadProgress();
        await this.service.render();
    }

    public async clearUploadFiles() {
        if (this.uploading) return;
        this.uploadFiles = [];
        this.uploadError = '';
        this.resetUploadProgress();
        await this.service.render();
    }

    public getFileExtension(name: string = ''): string {
        const ext = (name.split('.').pop() || '').trim().toUpperCase();
        return ext && ext !== name.toUpperCase() ? ext : 'FILE';
    }

    public formatFileSize(size: number = 0): string {
        if (!Number.isFinite(size) || size <= 0) return '0 B';
        const units = ['B', 'KB', 'MB', 'GB'];
        let value = size;
        let unitIndex = 0;
        while (value >= 1024 && unitIndex < units.length - 1) {
            value = value / 1024;
            unitIndex += 1;
        }
        const digits = unitIndex === 0 || value >= 10 ? 0 : 1;
        return `${value.toFixed(digits)} ${units[unitIndex]}`;
    }

    public getUploadTotalSize(): string {
        return this.formatFileSize(this.uploadFiles.reduce((sum, file) => sum + (file.size || 0), 0));
    }

    private getInitialUploadProgress() {
        return {
            percent: 0,
            phase: '대기 중',
            detail: '',
            step: 'idle'
        };
    }

    private resetUploadProgress() {
        this.stopUploadProgressTimer();
        this.uploadProgress = this.getInitialUploadProgress();
    }

    private setUploadProgress(progress: any) {
        this.uploadProgress = {
            ...this.uploadProgress,
            ...progress,
            percent: Math.max(0, Math.min(100, Math.round(progress?.percent ?? this.uploadProgress.percent ?? 0)))
        };
    }

    private stopUploadProgressTimer() {
        if (this.uploadProgressTimer) {
            clearInterval(this.uploadProgressTimer);
            this.uploadProgressTimer = null;
        }
    }

    private startParsingProgress() {
        this.stopUploadProgressTimer();
        this.setUploadProgress({
            percent: Math.max(this.uploadProgress.percent || 0, 72),
            phase: 'RFP 텍스트 추출 중',
            detail: '업로드한 PDF/HWPX/DOCX 본문을 읽고 있습니다. 큰 문서는 잠시 걸릴 수 있습니다.',
            step: 'parse'
        });
        this.uploadProgressTimer = setInterval(() => {
            if (!this.uploading) {
                this.stopUploadProgressTimer();
                return;
            }
            const current = this.uploadProgress.percent || 72;
            const increment = current < 84 ? 3 : current < 92 ? 2 : 1;
            this.setUploadProgress({
                percent: Math.min(94, current + increment),
                phase: 'RFP 텍스트 추출 중',
                detail: '서버에서 문서 페이지와 본문 텍스트를 추출하고 있습니다.',
                step: 'parse'
            });
            this.service.render();
        }, 1100);
    }

    private uploadRfpWithProgress(formData: FormData): Promise<any> {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open('POST', wiz.url('upload_rfp'), true);
            xhr.withCredentials = true;

            xhr.upload.onprogress = (event: ProgressEvent) => {
                if (event.lengthComputable) {
                    const transferRatio = event.total > 0 ? event.loaded / event.total : 0;
                    const percent = Math.max(3, Math.min(70, Math.round(transferRatio * 70)));
                    this.setUploadProgress({
                        percent,
                        phase: '파일 전송 중',
                        detail: `${this.formatFileSize(event.loaded)} / ${this.formatFileSize(event.total)} 전송`,
                        step: 'upload'
                    });
                } else {
                    this.setUploadProgress({
                        percent: Math.max(this.uploadProgress.percent || 0, 8),
                        phase: '파일 전송 중',
                        detail: '파일을 서버로 보내고 있습니다.',
                        step: 'upload'
                    });
                }
                this.service.render();
            };

            xhr.upload.onload = () => {
                this.startParsingProgress();
                this.service.render();
            };

            xhr.onreadystatechange = () => {
                if (xhr.readyState !== 4) return;
                this.stopUploadProgressTimer();
                const rawText = xhr.responseText || '';
                let result = null;
                try {
                    result = rawText ? JSON.parse(rawText) : null;
                } catch {
                    result = null;
                }
                resolve({
                    status: xhr.status,
                    rawText,
                    result
                });
            };

            xhr.onerror = () => {
                this.stopUploadProgressTimer();
                reject(new Error('네트워크 오류로 업로드가 중단되었습니다.'));
            };
            xhr.onabort = () => {
                this.stopUploadProgressTimer();
                reject(new Error('업로드가 취소되었습니다.'));
            };

            xhr.send(formData);
        });
    }

    public async submitUpload() {
        if (!this.uploadTitle.trim() || this.uploadFiles.length === 0) return;
        if (this.uploading) return;

        this.uploadError = '';
        this.uploading = true;
        this.setUploadProgress({
            percent: 1,
            phase: '업로드 준비 중',
            detail: `${this.uploadFiles.length}개 파일을 전송할 준비를 하고 있습니다.`,
            step: 'prepare'
        });
        await this.service.render();

        let errorMessage = '업로드에 실패했습니다.';

        try {
            let formData = new FormData();
            formData.append('title', this.uploadTitle.trim());
            formData.append('org_name', this.uploadOrg.trim());
            for (let f of this.uploadFiles) {
                formData.append('file', f);
            }

            let uploadResult = await this.uploadRfpWithProgress(formData);
            let result = uploadResult.result;
            let rawText = uploadResult.rawText || '';
            let responseStatus = uploadResult.status || 0;

            if (result?.code === 200 && result.data?.notice_no) {
                this.setUploadProgress({
                    percent: 100,
                    phase: '완료',
                    detail: 'RFP 등록이 완료되었습니다. RFP 분석 화면으로 이동합니다.',
                    step: 'done'
                });
                await this.service.render();
                this.showUploadModal = false;
                this.uploading = false;
                this.service.href(`/analysis/${encodeURIComponent(result.data.notice_no)}?from=project`);
                return;
            }

            errorMessage = result?.data?.message || result?.message || this.extractErrorMessage(rawText) || `업로드에 실패했습니다. (${responseStatus})`;
        } catch (e: any) {
            errorMessage = e?.message || errorMessage;
        }

        this.stopUploadProgressTimer();
        this.uploading = false;
        this.setUploadProgress({
            percent: 0,
            phase: '업로드 실패',
            detail: '',
            step: 'error'
        });
        this.uploadError = errorMessage;
        await this.service.render();
    }

    private extractErrorMessage(rawText: string): string {
        if (!rawText) return '';

        let stripped = rawText
            .replace(/<style[\s\S]*?<\/style>/gi, ' ')
            .replace(/<script[\s\S]*?<\/script>/gi, ' ')
            .replace(/<[^>]+>/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();

        if (!stripped) return '';
        if (/login|sign in|unauthorized|forbidden/i.test(stripped)) {
            return '로그인 세션이 만료되었거나 권한이 없습니다. 다시 로그인 후 시도해주세요.';
        }

        return stripped.slice(0, 240);
    }

    // ── Helpers ──

    public getStatusLabel(status: string): string {
        const map: any = { draft: '초안', writing: '작성 중', done: '완료' };
        return map[status] || status || '';
    }

    public getSourceLabel(item: any): string {
        if (this.isCodexItem(item)) return 'Codex';
        return this.isManualSource(item) ? '직접 업로드' : '나라장터';
    }

    private getSource(item: any): string {
        return String(item?.source || '').trim().toLowerCase();
    }

    public isCodexItem(item: any): boolean {
        const source = this.getSource(item);
        return item?.is_codex === true || source.includes('codex');
    }

    private isManualSource(item: any): boolean {
        const source = this.getSource(item);
        return source === 'manual' || source === 'proposal_upload';
    }

    public isManualItem(item: any): boolean {
        return this.isManualSource(item);
    }

    private isScrapSource(item: any): boolean {
        return !this.isManualSource(item) && !this.isCodexItem(item);
    }

    public get manualCount(): number {
        return this.items.filter((item: any) => this.isManualSource(item)).length;
    }

    public get scrapCount(): number {
        return this.items.filter((item: any) => this.isScrapSource(item)).length;
    }

    public get writingCount(): number {
        return this.items.filter((item: any) => item?.proposal_status === 'writing' || item?.proposal_status === 'draft' || item?.deck_status === 'writing' || item?.deck_status === 'planning' || item?.deck_status === 'draft').length;
    }

    public get doneCount(): number {
        return this.items.filter((item: any) => item?.proposal_status === 'done').length;
    }

    public async setProposalFilter(filter: string) {
        this.proposalFilter = filter;
        this.page = 1;
        await this.service.render();
    }

    public get filteredItems(): any[] {
        if (this.proposalFilter === 'manual') {
            return this.items.filter((item: any) => this.isManualSource(item));
        }
        if (this.proposalFilter === 'scrap') {
            return this.items.filter((item: any) => this.isScrapSource(item));
        }
        if (this.proposalFilter === 'writing') {
            return this.items.filter((item: any) => item?.proposal_status === 'writing' || item?.proposal_status === 'draft');
        }
        if (this.proposalFilter === 'done') {
            return this.items.filter((item: any) => item?.proposal_status === 'done');
        }
        return this.items;
    }

    public get pagedItems(): any[] {
        const start = (this.page - 1) * this.pageSize;
        return this.filteredItems.slice(start, start + this.pageSize);
    }

    public get totalPages(): number {
        return Math.ceil(this.filteredItems.length / this.pageSize) || 1;
    }

    public get pageStart(): number {
        if (this.filteredItems.length === 0) return 0;
        return (this.page - 1) * this.pageSize + 1;
    }

    public get pageEnd(): number {
        return Math.min(this.page * this.pageSize, this.filteredItems.length);
    }

    public get pageRange(): number[] {
        let pages: number[] = [];
        let start = Math.max(1, this.page - 2);
        let end = Math.min(this.totalPages, start + 4);
        start = Math.max(1, end - 4);
        for (let i = start; i <= end; i++) pages.push(i);
        return pages;
    }

    public async goPage(p: number) {
        if (p < 1 || p > this.totalPages) return;
        this.page = p;
        await this.service.render();
    }

    public getProjectActionLabel(item: any): string {
        if (this.isCodexItem(item)) return '프로젝트 열기';
        if (item?.rfp_status !== 'done') return 'RFP 분석';
        if (!item?.proposal_id) return '제안서 작성';
        return '프로젝트 열기';
    }

    public getRfpStatusLabel(item: any): string {
        if (item.rfp_status === 'done') return '분석 완료';
        if (item.rfp_status === 'partial') return '부분 완료';
        if (item.rfp_status === 'processing') return '분석 중';
        if (item.rfp_status === 'pending') return '분석 대기';
        if (item.rfp_status === 'none') return '미등록';
        return '분석 대기';
    }

    public getDeckStatusLabel(item: any): string {
        if (!item?.deck_count) return '미작성';
        if (item.deck_status === 'done') return '완료';
        if (item.deck_status === 'planning') return '구성 중';
        if (item.deck_status === 'writing') return '작성 중';
        if (item.deck_status === 'draft') return '초안';
        return '있음';
    }

    public getDday(deadline: string): number | null {
        if (!deadline) return null;
        try {
            let dt: Date;
            if (deadline.includes('-')) { dt = new Date(deadline); }
            else if (deadline.length >= 8) { dt = new Date(`${deadline.substring(0, 4)}-${deadline.substring(4, 6)}-${deadline.substring(6, 8)}`); }
            else { return null; }
            let now = new Date(); now.setHours(0, 0, 0, 0); dt.setHours(0, 0, 0, 0);
            return Math.ceil((dt.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
        } catch { return null; }
    }

    public getDdayText(days: number | null): string {
        if (days === null) return '-';
        if (days === 0) return 'D-Day';
        if (days > 0) return `D-${days}`;
        return `D+${Math.abs(days)}`;
    }
}

export default PageProposalComponent;